export const THEME = {
  LIGHT: 'day',
  DARK: 'night',
}
